// extracted by mini-css-extract-plugin
export default {"page":"Emotion_page__FXSmK","background":"Emotion_background__DCXGs"};